var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseElButton',_vm._b({staticClass:"table-setting-icon-btutton",attrs:{"type":"text"},on:{"click":function($event){return _vm.$emit('click')}}},'BaseElButton',_vm.$attrs,false),[_c('span',{staticClass:"material-icons"},[_vm._v(" settings ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }